import { create } from 'zustand'

export type User = {
  name: string
  email: string
  avatarInitials: string
  plan: string
  /** Admin flag for site management access (S10-03) */
  is_admin?: boolean
  /** Associated site ID for whitelabel users (S10-03) */
  site_id?: number | null
}

type UserStore = {
  user: User | null
  /** Wird nach erfolgreichem Login/Account-Load mit echten Daten befüllt (FIN-SWEEP shell-dashboard). */
  setUser: (user: User) => void
  /** Wird beim Logout aufgerufen, damit keine Nutzerdaten des vorherigen Users hängen bleiben. */
  clearUser: () => void
}

export const useUserStore = create<UserStore>((set) => ({
  user: null,
  setUser: (user) => set({ user }),
  clearUser: () => set({ user: null }),
}))

/**
 * Leitet die Initialen aus einem Anzeigenamen/E-Mail-Local-Part ab.
 * "max.mustermann" -> "MM", "demo" -> "DE" (erste zwei Zeichen als Fallback).
 */
export function computeInitials(source: string): string {
  const parts = source.split(/[.\-_\s]+/).filter(Boolean)
  if (parts.length >= 2) {
    return (parts[0][0] + parts[1][0]).toUpperCase()
  }
  return source.slice(0, 2).toUpperCase() || 'U'
}

/**
 * Baut das User-Store-Shape aus den Account-Daten (GET /api/v2/account/me).
 * Der Account hat kein eigenes "Name"-Feld — der E-Mail-Local-Part dient als
 * Anzeigename, die Initialen werden daraus abgeleitet.
 */
export function accountToUser(account: {
  email: string
  plan: string
  is_admin?: boolean
  site_id?: number | null
}): User {
  const localPart = account.email.split('@')[0] || account.email
  return {
    name: localPart,
    email: account.email,
    avatarInitials: computeInitials(localPart),
    plan: account.plan,
    is_admin: account.is_admin,
    site_id: account.site_id,
  }
}
